import candidateApi from '~/clientApis/candidateApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { Candidate } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

export const unlinkMedia = async (): Promise<void> => {
    const { candidateStore } = getStore();
    const selectedCandidate = candidateStore.getSelectedCandidate() as Candidate;

    if (!selectedCandidate) return;

    const assetId = selectedCandidate.picture;
    if (assetId === '') return;

    try {
        await candidateApi.unlinkMedia(candidateStore.selectedCandidateId, assetId);
    } catch {
        showMessageModal('error', 'Failed to unlink candidate asset');
    }
};
